module.exports = __webpack_public_path__ + "img/center_left.be41d688.svg";